<template>
  <div v-if="!error && isVisible && text" class="bg-pine-950">
    <div class="container flex md:text-center items-center justify-between w-full py-2">
      <div class="flex-1">
        <component :is="linkConfig.element" v-bind="linkConfig.attrs" class="overflow-hidden text-gold-100 decoration-gold-100">
          {{ text }}
          <span v-if="link">&#8250;</span>
        </component>
      </div>
      <BaseButton look="blank" class="p-0 h-8 w-8 flex  hover:bg-pine-600 text-gold-100" @click="close">
        <XMarkIcon class="size-5" />
      </BaseButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'

const isVisible = ref(true)

const { getGlobalMessageData } = useLexas()
const { data: message, error } = await getGlobalMessageData()

const text = message.value?.text
const link = message.value?.link ?? ''

// Check if the link is external - http or https
const isExternal = /^(http|https):\/\//.test(link)
const NuxtLink = resolveComponent('NuxtLink')

// Link configuration for <component> element
const linkConfig = computed(() =>
  link
    ? isExternal
    // Anchor element if external
      ? { element: 'a', attrs: { href: link, target: '_blank', rel: 'noopener noreferrer' } }
      // NuxtLink if internal
      : { element: NuxtLink, attrs: { to: link } }
  // div if link doesn't exist
    : { element: 'div', attrs: {} }
)

// Close handler for Global Message
const close = () => {
  isVisible.value = false
}
</script>
